<template>
  <div class="faq-page">
    <div class="faq-page__decor" aria-hidden="true" />
    <div class="faq-page__shell">
      <header class="faq-page__intro">
        <span class="faq-page__badge">FAQ</span>
        <h1 class="faq-page-title">{{ $t("message.faq_title") }}</h1>
        <p class="faq-page-description">{{ $t("message.faq_page_description") }}</p>
      </header>
      <el-collapse v-model="activeName" accordion @change="handleCollapseChange" class="faq-collapse">
      <el-collapse-item name="1">
        <template #title>{{ $t("message.faq_section1_title") }}</template>
        <div class="section-content">
          <div v-html='$t("message.faq_section1_content1")'></div>
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template #title>{{ $t("message.faq_section2_title") }}</template>
        <div class="section-content">
          <div>
            <p v-html='$t("message.faq_section2_content1")'></p>
            <p v-html='$t("message.faq_section2_content2")'></p>
            <p v-html='$t("message.faq_section2_content3")'></p>
            <p v-html='$t("message.faq_section2_content4")'></p>
            <p v-html='$t("message.faq_section2_content5")'></p>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item name="3">
        <template #title>{{ $t("message.faq_section3_title") }}</template>
        <div class="section-content">
          <div>
            <p v-html='$t("message.faq_section3_content1")'></p>
            <p v-html='$t("message.faq_section3_content2")'></p>
            <p>{{ $t("message.faq_section3_content3") }}</p>
            <p v-html='$t("message.faq_section3_content4")'></p>
            <p v-html='$t("message.faq_section3_content5")'></p>
            <p v-html='$t("message.faq_section3_content6")'></p>
            <p v-html='$t("message.faq_section3_content7")'></p>
            <p v-html='$t("message.faq_section3_content8")'></p>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item name="4">
        <template #title>{{ $t("message.faq_section4_title") }}</template>
        <div class="section-content">
          <div>{{ $t("message.faq_section4_content1") }}</div>
        </div>
      </el-collapse-item>
      <el-collapse-item name="5">
        <template #title>{{ $t("message.faq_section5_title") }}</template>
        <div class="section-content">
          <div>{{ $t("message.faq_section5_content1") }}</div>
        </div>
      </el-collapse-item>
      <el-collapse-item name="6">
        <template #title>{{ $t("message.faq_section6_title") }}</template>
        <div class="section-content">
          <div>
            <p>{{ $t("message.faq_section6_content1") }}</p>
            <p v-html='$t("message.faq_section6_content2")'></p>
            <div class="image-step-container">
              <p class="step-title"><b>{{ $t("message.browser_step1") }}</b></p>
              <div class="image-wrapper">
                <img class="step-image" src="../images/step1.jpg" alt="Secret Vault private browser step 1 tutorial screenshot">
                <span class="step-overlay-text">{{ $t("message.browser_step1_tip") }}</span>
              </div>
            </div>
            <div class="image-step-container">
              <p class="step-title"><b>{{ $t("message.browser_step2") }}</b></p>
              <div class="image-wrapper">
                <img class="step-image" src="../images/step2.jpg" alt="Secret Vault private browser step 2 tutorial screenshot">
                <span class="step-overlay-text">{{ $t("message.browser_step2_tip") }}</span>
              </div>
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item name="7">
        <template #title>{{ $t("message.faq_section7_title") }}</template>
        <div class="section-content">
          <div>
            <p v-html='$t("message.faq_section7_content1")'></p>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item name="8">
        <template #title>{{ $t("message.faq_section8_title") }}</template>
        <div class="section-content">
          <div>
            <p v-html='$t("message.faq_section8_content1")'></p>
            <p v-html='$t("message.faq_section8_content2")'></p>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item name="9">
        <template #title>{{ $t("message.faq_section9_title") }}</template>
        <div class="section-content">
          <div>
            <p v-html='$t("message.faq_section9_content1")'></p>
            <p v-html='$t("message.faq_section9_content2")'></p>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item name="10">
        <template #title>{{ $t("message.faq_section10_title") }}</template>
        <div class="section-content">
          <div>
            <p v-html='$t("message.faq_section10_content1")'></p>
            <p v-html='$t("message.faq_section10_content2")'></p>
            <img v-if="loadedImages.includes('10')" class="gif" src="./../images/export_from_safari.gif" alt="Secret Vault export photos from Safari browser tutorial" loading="lazy">
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item name="11">
        <template #title>{{ $t("message.faq_section11_title") }}</template>
        <div class="section-content">
          <div>
            <p v-html='$t("message.faq_section11_content1")'></p>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item name="12">
        <template #title>{{ $t("message.faq_section12_title") }}</template>
        <div class="section-content">
          <div>{{ $t("message.faq_section12_content1") }}</div>
        </div>
      </el-collapse-item>

    </el-collapse>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        activeName: '1',
        title: 'faq',
        loadedImages: [] // 跟踪已加载图片的collapse项
      }
    },
    methods: {
      handleCollapseChange(activeName) {
        // 当collapse项展开时，将对应的name添加到loadedImages数组
        // accordion 模式下 activeName 是字符串
        if (activeName && !this.loadedImages.includes(activeName)) {
          this.loadedImages.push(activeName)
        }
      },
      getImageUrl(imageName) {
        return new URL(`../images/${imageName}`, import.meta.url).href
      }
    }
  }
</script>

<style scoped lang="scss">
// 与首页 home.vue 对齐的设计变量（FAQ 独立页）
$c-near-black: #1c1c1e;
$c-slate: #555a6a;
$c-blue: #5b76fe;
$font-display: 'Plus Jakarta Sans', 'DM Sans', system-ui, -apple-system, sans-serif;
$font-body: 'Noto Sans', system-ui, -apple-system, sans-serif;

.faq-page {
  position: relative;
  min-height: 100vh;
  overflow-x: hidden;
  box-sizing: border-box;
  padding: calc(16px + env(safe-area-inset-top, 0px)) 16px calc(28px + env(safe-area-inset-bottom, 0px));
  font-family: $font-body;
  color: $c-near-black;
  /* 与首页截图区 / pastel 卡片气质一致：浅色底 + 柔和渐变 */
  background: linear-gradient(165deg, #e8f0ff 0%, #f4f6f9 38%, #faf6fb 72%, #f8fafc 100%);

  @media (min-width: 768px) {
    padding: 40px 24px 48px;
  }

  &__decor {
    pointer-events: none;
    position: absolute;
    inset: 0;
    z-index: 0;
    /* 纯 CSS，移动端友好；模拟首页 hero pastel + feature 配色光晕 */
    background:
      radial-gradient(ellipse 130% 85% at 100% -5%, rgba($c-blue, 0.16), transparent 52%),
      radial-gradient(ellipse 95% 70% at -12% 35%, rgba(195, 250, 245, 0.65), transparent 48%),
      radial-gradient(ellipse 75% 55% at 88% 92%, rgba(255, 216, 244, 0.45), transparent 42%);
  }

  &__shell {
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 100%;
    margin: 0 auto;

    @media (min-width: 768px) {
      max-width: 900px;
    }

    @media (min-width: 1024px) {
      max-width: 1000px;
    }
  }

  &__intro {
    text-align: center;
    margin-bottom: 28px;

    @media (min-width: 768px) {
      margin-bottom: 36px;
    }
  }

  &__badge {
    display: inline-block;
    font-family: $font-display;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    color: #2a41b6;
    background: rgba($c-blue, 0.12);
    border-radius: 999px;
    padding: 6px 14px;
    margin-bottom: 14px;
  }

  .faq-page-title {
    font-family: $font-display;
    font-size: clamp(26px, 6vw, 36px);
    font-weight: 700;
    color: $c-near-black;
    margin: 0 0 12px;
    line-height: 1.15;
    letter-spacing: -0.04em;

    @media (min-width: 768px) {
      margin-bottom: 16px;
    }
  }

  .faq-page-description {
    font-size: 16px;
    color: $c-slate;
    margin: 0 auto;
    max-width: 34em;
    line-height: 1.55;

    @media (min-width: 768px) {
      font-size: 17px;
    }
  }

  // Element Plus Collapse（折叠项背景恢复为原版灰底 / 展开浅蓝）
  .faq-collapse {
    border: none;
  }

  :deep(.faq-collapse.el-collapse),
  :deep(.el-collapse) {
    border: none;
    background: transparent;
  }

  :deep(.el-collapse-item) {
    margin-bottom: 15px;
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    overflow: hidden;
    transition: all 0.3s ease;
    background: #ffffff;

    @media (min-width: 768px) {
      margin-bottom: 20px;
      border-radius: 10px;
    }

    &:hover {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  :deep(.el-collapse-item__header) {
    padding: 15px 20px;
    min-height: 48px;
    font-size: 15px;
    font-weight: 500;
    font-family: $font-body;
    color: #333;
    line-height: 1.35;
    background-color: #fafafa;
    transition: all 0.3s ease;

    @media (min-width: 768px) {
      padding: 18px 25px;
      font-size: 16px;
      min-height: 52px;
    }

    &:hover {
      background-color: #f5f7fa;
      color: #00a7ff;
    }

    &.is-active {
      color: #00a7ff;
      background-color: #f0f9ff;
    }
  }

  :deep(.el-collapse-item__wrap) {
    border-bottom: none;
    background: #ffffff;
  }

  :deep(.el-collapse-item__content) {
    padding: 20px;
    font-size: 14px;
    line-height: 1.8;
    color: #666;
    background-color: #ffffff;

    @media (min-width: 768px) {
      padding: 25px 30px;
      font-size: 15px;
      line-height: 1.9;
    }
  }
}

.section-content {
  color: $c-slate;
  margin-bottom: 12px;
  line-height: 1.8;

  @media (min-width: 768px) {
    margin-bottom: 15px;
    line-height: 1.9;
  }

  &:last-child {
    margin-bottom: 0;
  }

  a {
    color: $c-blue;
    text-decoration: none;
    font-weight: 600;
    transition: color 0.2s ease;

    &:hover {
      text-decoration: underline;
    }
  }

  strong {
    font-weight: 600;
    color: $c-near-black;
  }

  b {
    font-weight: 600;
    color: $c-near-black;
    display: block;
    margin: 15px 0 10px 0;
    font-size: 15px;

    @media (min-width: 768px) {
      margin: 20px 0 12px 0;
      font-size: 16px;
    }
  }
}

.gif {
  display: block;
  width: 100%;
  max-width: 100%;
  height: auto;
  margin: 15px 0;
  padding: 10px 0;
  border-radius: 8px;

  @media (min-width: 768px) {
    max-width: 600px;
    margin: 20px auto;
    padding: 15px 0;
    border-radius: 10px;
  }

  @media (min-width: 1024px) {
    max-width: 700px;
  }
}

.guide-text {
  position: absolute;
  left: 0;
  width: 100%;
  padding: 0 20px;
  text-align: center;
  color: red;
  font-size: 20px;
  text-shadow: 2px 2px 5px white;
  font-weight: 600;
  pointer-events: none;

  @media (min-width: 768px) {
    font-size: 24px;
    padding: 0 40px;
  }

  @media (min-width: 1024px) {
    font-size: 26px;
  }
}

// 新的响应式图片步骤样式
.image-step-container {
  margin: 20px 0;
  
  @media (min-width: 768px) {
    margin: 30px 0;
  }
}

.step-title {
  font-weight: 600;
  color: $c-near-black;
  font-size: 15px;
  margin-bottom: 10px;
  
  @media (min-width: 768px) {
    font-size: 16px;
    margin-bottom: 12px;
  }

  b {
    margin: 0;
  }
}

.image-wrapper {
  position: relative;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  
  @media (min-width: 768px) {
    max-width: 500px;
  }
  
  @media (min-width: 1024px) {
    max-width: 600px;
  }
}

.step-image {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  
  @media (min-width: 768px) {
    border-radius: 10px;
  }
}

.step-overlay-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  text-align: center;
  color: #ff4444;
  font-size: 14px;
  font-weight: 700;
  text-shadow: 
    -1px -1px 0 #fff,  
     1px -1px 0 #fff,
    -1px  1px 0 #fff,
     1px  1px 0 #fff,
     0px  2px 4px rgba(0,0,0,0.3);
  pointer-events: none;
  line-height: 1.4;
  
  @media (min-width: 375px) {
    font-size: 15px;
  }
  
  @media (min-width: 414px) {
    font-size: 16px;
  }
  
  @media (min-width: 768px) {
    font-size: 18px;
  }
  
  @media (min-width: 1024px) {
    font-size: 20px;
  }
}

</style>
